"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLobbyOnInit = void 0;
const react_1 = require("react");
function useLobbyOnInit(onInit) {
    if (!onInit) {
        throw new Error('onInit must be defined');
    }
    const [invoked, setInvoked] = (0, react_1.useState)(false);
    const [initialized, setInitialized] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!invoked) {
            setInvoked(true);
            onInit()
                .then(() => void setInitialized(true))
                .catch(() => void setInitialized(true));
        }
    }, [onInit, invoked]);
    return initialized;
}
exports.useLobbyOnInit = useLobbyOnInit;
//# sourceMappingURL=use_lobby_on_init.js.map